import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_11c05fe0 from 'nuxt_plugin_plugin_11c05fe0' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_pluginsdynamic265cddb6_695a16e2 from 'nuxt_plugin_pluginsdynamic265cddb6_695a16e2' // Source: ./plugins.dynamic.265cddb6.js (mode: 'all')
import nuxt_plugin_bootstrapvue_646beb55 from 'nuxt_plugin_bootstrapvue_646beb55' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_nuxtmq_3c7a62ae from 'nuxt_plugin_nuxtmq_3c7a62ae' // Source: ./nuxt-mq.js (mode: 'all')
import nuxt_plugin_axios_2bed9326 from 'nuxt_plugin_axios_2bed9326' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_deviceplugin_516aa4b1 from 'nuxt_plugin_deviceplugin_516aa4b1' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_c1device_b57513c2 from 'nuxt_plugin_c1device_b57513c2' // Source: ../plugins/c1-device (mode: 'all')
import nuxt_plugin_hostname_3d454bae from 'nuxt_plugin_hostname_3d454bae' // Source: ../plugins/hostname.js (mode: 'all')
import nuxt_plugin_sitesettings_75e55433 from 'nuxt_plugin_sitesettings_75e55433' // Source: ../plugins/site-settings (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_staticroutes_8c69205a from 'nuxt_plugin_staticroutes_8c69205a' // Source: ../plugins/static-routes (mode: 'all')
import nuxt_plugin_veevalidate_6e5ad03a from 'nuxt_plugin_veevalidate_6e5ad03a' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_lazysizes_63bafee8 from 'nuxt_plugin_lazysizes_63bafee8' // Source: ../plugins/lazysizes (mode: 'all')
import nuxt_plugin_vueobservevisibility_2d7eef00 from 'nuxt_plugin_vueobservevisibility_2d7eef00' // Source: ../plugins/vue-observe-visibility (mode: 'all')
import nuxt_plugin_mountedclient_0a741cc0 from 'nuxt_plugin_mountedclient_0a741cc0' // Source: ../plugins/mounted.client.js (mode: 'client')
import nuxt_plugin_manifest_0a3f18b6 from 'nuxt_plugin_manifest_0a3f18b6' // Source: ../plugins/manifest (mode: 'all')
import nuxt_plugin_components_6fb0430c from 'nuxt_plugin_components_6fb0430c' // Source: ../plugins/components (mode: 'all')
import nuxt_plugin_fbinappdetect_49d08cc8 from 'nuxt_plugin_fbinappdetect_49d08cc8' // Source: ../plugins/fb-in-app-detect (mode: 'client')
import nuxt_plugin_velocityanimate_9146d532 from 'nuxt_plugin_velocityanimate_9146d532' // Source: ../plugins/velocity-animate (mode: 'client')
import nuxt_plugin_directives_d0867c0c from 'nuxt_plugin_directives_d0867c0c' // Source: ../plugins/directives (mode: 'client')
import nuxt_plugin_fontawesome_b8d42804 from 'nuxt_plugin_fontawesome_b8d42804' // Source: ../plugins/fontawesome (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"viewport-fit=contain, width=device-width, initial-scale=1, user-scalable=no"},{"hid":"fb:app_id","property":"fb:app_id","content":"274611636258579"},{"hid":"robots","name":"robots","content":"index, follow"},{"hid":"og:type","property":"og:type","content":"website"},{"name":"theme-color","content":"#fff"}],"link":[{"rel":"publisher","href":"https:\u002F\u002Fplus.google.com\u002F112205400869314189261\u002Fabout"}],"script":[{"src":"\u002Fjobs\u002Fbrowser-update.js","async":true,"defer":true}],"noscript":[{"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-MB79ZS\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"\u003E\u003C\u002Fiframe\u003E","body":true}],"__dangerouslyDisableSanitizers":["script","noscript"],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_11c05fe0 === 'function') {
    await nuxt_plugin_plugin_11c05fe0(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsdynamic265cddb6_695a16e2 === 'function') {
    await nuxt_plugin_pluginsdynamic265cddb6_695a16e2(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_646beb55 === 'function') {
    await nuxt_plugin_bootstrapvue_646beb55(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtmq_3c7a62ae === 'function') {
    await nuxt_plugin_nuxtmq_3c7a62ae(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2bed9326 === 'function') {
    await nuxt_plugin_axios_2bed9326(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_516aa4b1 === 'function') {
    await nuxt_plugin_deviceplugin_516aa4b1(app.context, inject)
  }

  if (typeof nuxt_plugin_c1device_b57513c2 === 'function') {
    await nuxt_plugin_c1device_b57513c2(app.context, inject)
  }

  if (typeof nuxt_plugin_hostname_3d454bae === 'function') {
    await nuxt_plugin_hostname_3d454bae(app.context, inject)
  }

  if (typeof nuxt_plugin_sitesettings_75e55433 === 'function') {
    await nuxt_plugin_sitesettings_75e55433(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_staticroutes_8c69205a === 'function') {
    await nuxt_plugin_staticroutes_8c69205a(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_6e5ad03a === 'function') {
    await nuxt_plugin_veevalidate_6e5ad03a(app.context, inject)
  }

  if (typeof nuxt_plugin_lazysizes_63bafee8 === 'function') {
    await nuxt_plugin_lazysizes_63bafee8(app.context, inject)
  }

  if (typeof nuxt_plugin_vueobservevisibility_2d7eef00 === 'function') {
    await nuxt_plugin_vueobservevisibility_2d7eef00(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mountedclient_0a741cc0 === 'function') {
    await nuxt_plugin_mountedclient_0a741cc0(app.context, inject)
  }

  if (typeof nuxt_plugin_manifest_0a3f18b6 === 'function') {
    await nuxt_plugin_manifest_0a3f18b6(app.context, inject)
  }

  if (typeof nuxt_plugin_components_6fb0430c === 'function') {
    await nuxt_plugin_components_6fb0430c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fbinappdetect_49d08cc8 === 'function') {
    await nuxt_plugin_fbinappdetect_49d08cc8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_velocityanimate_9146d532 === 'function') {
    await nuxt_plugin_velocityanimate_9146d532(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_directives_d0867c0c === 'function') {
    await nuxt_plugin_directives_d0867c0c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fontawesome_b8d42804 === 'function') {
    await nuxt_plugin_fontawesome_b8d42804(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
